<template>
  <div class="purchaseDetail_wrapper">
      <div class="check_Top">
        <div class="check_header">
             <el-button size="small" @click="goBack()"  type="primary"><i class="iconfont icon-fanhui-"></i> {{$t('other.a605')}}</el-button>
            
        </div>
     
        <div class="check_desc">
           <span class="sec_item">
                <span class="check_desc_item">
				    {{$t('other.a2120')}}：<el-date-picker
					size="small"
					style="width: 250px;"
					v-model="value1"
                    @change="jvmf()"
					type="date"
					:placeholder="$t('other.a2123')">
				</el-date-picker>
				
                </span>
                <span class="check_desc_item">{{$t('other.a2103')}}：
                    <el-input style="width: 250px;" onkeyup="value=value.replace(/[^\d\.]/g,'')" @blur='showPrice=false' @focus="showPrice=true" size="small" v-model="shipCost" :placeholder="$t('other.a2106')"></el-input>
			        <span v-show="showPrice" style="margin-left:15px;color:red">{{$t('other.a2121')}}</span>
                </span>
                <span class="check_desc_item">{{$t('other.a2122')}}：{{calTotal}}</span>
           </span>
           <div>
            <el-button v-show="!purchaseOrderId" style="margin-right:20px"  type="primary" @click="createPurchaseId()">{{$t('other.a2124')}}</el-button>
            <el-button v-show="purchaseOrderId && purchaseOrderStatus"  type="primary" @click="addNewProduct()">{{$t('other.a2125')}}</el-button>
            <el-button v-show="purchaseOrderId && purchaseOrderStatus" style="margin-right:20px"  type="danger" @click="sellerUpdat()">{{$t('other.a2126')}}</el-button>
           </div>
          
           
        </div>
      </div>
      <div class="check_table">
        <div class="check_title" @click="toggleSelection(tableData[1])">{{$t('other.a406')}}{{$t('other.a2127')}}：
            <el-switch v-model="fbsBool" @change="chageFbsTtype()" :active-text="$t('other.a2128')" :inactive-text="$t('other.a2129')">
            </el-switch>
            
        </div>
        <el-table
				 size="mini"
				 ref="multipleTable"
                 border
                 @select="select"
                 @select-all="selectAll"
                
				 :data="tableData"
				style="width: 100%">
				 <el-table-column
                    type="selection"
                    width="55">
                    </el-table-column>
				<el-table-column
			        prop="country"
			        :label="$t('other.a481')"
			        width="80">
					<template slot-scope="props">
						<span>{{getCountry(props.row.country)}}</span>
					</template>
			      </el-table-column>
			      <el-table-column
			        prop="goodType"
			        :label="$t('other.a775')"
			       >
					<template slot-scope="props">
						<span>{{conversion(props.row.goodType) }}</span>
					</template>
			      </el-table-column>
			      <el-table-column
			        prop="feeType"
			        :label="$t('other.a2130')"
					
					>
					<template slot-scope="props">
						<span>{{props.row.fee}} RMB/{{props.row.feeType == 1 ? $t('other.a2133') : props.row.feeType == 2 ? $t('other.a2134') : $t('other.a2135')}}</span>
					</template>
			      </el-table-column>
				  <el-table-column
				    :label="$t('other.a616')"
					>
					<template >
						<span>{{totalWeight}} KG</span>
					</template>
				  </el-table-column>
				  <el-table-column
				    prop="phone"
				    :label="$t('other.a2131')"
					>
					<template>
						<span>{{totalVolume}} {{$t('other.a1513')}}</span>
					</template>
				  </el-table-column>
				  <el-table-column
				    prop="address"
				    :label="$t('other.a2132')">
					<template slot-scope="props">
						<span>{{(totalVolume* props.row.fee).toFixed(3)}}</span>
					</template>
				  </el-table-column>

				  
		</el-table>


         <div class="check_title">{{$t('other.a2136')}}：</div>
        <el-table :data="targetlist"  border>
					<el-table-column property="name" :label="$t('userStoreItems').caigou.Img" width="60" :show-overflow-tooltip="true">
						<template scope="scope">
							<el-popover placement="top-start" title="" trigger="hover">
								<img :src="scope.row.image" style="width: 150px;height: 150px" />
								<img slot="reference" :src="scope.row.image" style="width: 30px;height: 30px">
							</el-popover>
						</template>
					</el-table-column>
					<el-table-column property="cusCode" :label="$t('other.a67')" width="200" :show-overflow-tooltip="true"></el-table-column>
					<el-table-column property="skuName" label="sku"  :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column property="weight" :label="$t('other.a632')"  :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column property="totalVolume" :label="$t('other.a2107')"  :show-overflow-tooltip="true"></el-table-column>
					<el-table-column :label="$t('other.a2137')">
						<template scope="scope">
							<el-input style="width:80px;" v-show="purchaseOrderStatus || !purchaseOrderId" size="mini" v-model="scope.row.cost" ></el-input>
                            <span v-show="!purchaseOrderStatus && purchaseOrderId">{{scope.row.cost ? scope.row.cost : 0}}</span>
						</template>
					</el-table-column>
					<el-table-column :label="$t('other.a2108')">
						<template scope="scope">
							<el-input-number v-show="purchaseOrderStatus || !purchaseOrderId"  size="mini" :min="1" v-model="scope.row.num" ></el-input-number> 
                            <span v-show="!purchaseOrderStatus && purchaseOrderId">{{scope.row.num ? scope.row.num : scope.row.variantNum }}</span>
						</template>
					</el-table-column>
					<el-table-column :label="$t('userStoreItems').caigou.anthreName">
						<template scope="scope">
							<el-input v-show="purchaseOrderStatus || !purchaseOrderId" size="mini" v-model="scope.row.anotherName" clearable></el-input>
                            <span v-show="!purchaseOrderStatus && purchaseOrderId">{{scope.row.anotherName ? scope.row.anotherName : $t('other.a354')}}</span>
						</template>
					</el-table-column>
					<el-table-column :label="$t('userStoreItems').caigou.operate" >
						<template scope="scope">
							<el-button  v-show="purchaseOrderStatus || !purchaseOrderId" type="text" size="mini" @click="deleteChoose(scope.row,scope.$index)" style="width: 70px;">{{$t('userStoreItems').caigou.dele}}</el-button>
						</template>
					</el-table-column>
				</el-table>
        
       
       
      </div>
       <div v-if="!isEedit" class="textarea">
            <el-input
            type="textarea"
            :rows="3"
            :placeholder="$t('other.a897')"
            v-model="textarea">
            </el-input>
        </div>
  </div>
</template>

<script>
import userStoreItemsApi from '.././../api/moudles/userStoreItems'
import sellerpurchaseApi from '../../api/moudles/sellerpurchase'
import api from '../../api/api'
import utils from '../../utils/utils'
import { mapState, mapActions, mapMutations } from "vuex";
export default {
data(){
return{
    allStoreId:JSON.parse(localStorage.getItem('userInfo')).storeIds,
    userId:JSON.parse(localStorage.getItem('userInfo')).userId,
    getDataList:null,
    storeId:null,
    datalist:{},
    listCopy:{},
    isEedit:false,
    textarea:'',
    value1:'',
    showPrice:false,
    shipCost:'',
    tableData:[],
    purchaseOrderStatus:null,
    isChooseList:[],
    targetlist:[],
    multipleSelection:[],
    purchaseOrderId:null,
    actualDate:0,
    fbsBool:false,
    targetStoreId:null,
    
   
}
},

 computed: {
    ...mapState({
      userName: (state) => state.shopaccess.userInfo.userName,
     
    }),

    totalVolume(){	
        let totalVolumeHeigh=0
        this.targetlist.forEach(p =>{
            p.totalVolume= p.packageHeight*p.packageLength*p.packageWidth*Number(p.num)/1000000
            totalVolumeHeigh += p.packageHeight*p.packageLength*p.packageWidth
            totalVolumeHeigh=totalVolumeHeigh*Number(p.num)
        })

        let total=0
        this.targetlist.forEach(p => {
            total += p.totalVolume
        })
        return total.toFixed(6)
    },
    totalWeight(){
        console.log(this.targetlist)
        let totalWeight=0
        this.targetlist.forEach(p =>{
            totalWeight += p.weight*Number(p.num)
        })
        console.log(totalWeight)
        return totalWeight.toFixed(2)
    },


    calTotal(){
        let num=0
        this.targetlist.forEach(p => {
            num=parseInt(p.num) + num
        })
        return num
    },
},


created(){
   
    // this.getPurchaserData()
     this.init()
},
destroyed(){
    utils.cleanStorageData()
},
methods:{

    chageFbsTtype(){
        console.log(this.fbsBool);
        if(this.fbsBool){
            //获取自有头程物流
            this.getRules()
        }else{
            this.getSystemRules()
        }

    },
    //获取平台头程消息
    getSystemRules(){
        
         userStoreItemsApi
        .getRuler({storeId:this.targetStoreId,userId:this.userId})
        .then(res => {
            if(res.code === 200){
                console.log(res.data)
                this.tableData=res.data
                
            }
        })
    },
    getRules(){
        sellerpurchaseApi
        .getFbsRules({
            userId:this.userId,
        })
        .then(res => {
        if(res.code === 200 ){
        console.log('获取自有头程物流',res.data)
        this.tableData=res.data
        }else{
        this.$message.warning(res.msg)
        }
        })
    },

    addNewFbsItem(){
        this.tableData.push({
            address:null,
            consignee:null,
            country:null,
            fbsId:null,
            fee:null,
            feeType:null,
            goodType:null,
            phone:null,
        })
        console.log(this.tableData);
    },

    init(){
       let purchaseId=this.$route.query.purchaseId
       this.purchaseOrderId=purchaseId
       let data=null
       if(purchaseId){//修改入库单
           
          let  getDataList = {
                offset: 15,
                page: 0,
                purchaseOrderId: purchaseId,
                sellerId: null,
                storeIds: this.allStoreId,
                type: null,
                userId: this.userId
            }
         sellerpurchaseApi
         .getPurchaseOrder(getDataList)
         .then(res => {
             if(res.code === 200){
                 this.targetStoreId=res.data.list[0].storeId
                 
                 console.log('7474',res.data)
                
                 data=res.data.list[0]
                 this.purchaseOrderStatus=data.orderFlag == "UNAUDITED" ? true : false
                 this.storeId=data.storeId
                 this.value1=res.data.list[0].dateOfShip
                 this.shipCost=res.data.list[0].shippingCost
                 this.textarea=data.messageToSeller
                 res.data.list[0].variantList.forEach(p => {
                    p.num=p.variantNum
                    p.skuName=p.variantName
                    p.storeId=p.storeItem.storeId
                    p.variationId=p.storeItem.variationId
                })
                if(res.data.list[0].orderFlag !== "SELLER_AUDITED"){
                    this.targetlist=res.data.list[0].variantList
                    let list=JSON.parse(localStorage.getItem('purchaseItems'))
                    console.log(this.targetlist)
                    console.log(list)
                    if(list){
                        list.forEach(p => {
                        p.totalVolume=p.packageHeight*p.packageLength*p.packageWidth*Number(p.num)/1000000
                        let falg=this.targetlist.find(item => item.cusCode == p.cusCode)
                        let isStoreItem=this.targetlist.find(item => item.storeId !== p.storeId)


                        if(falg){
                            this.$message.warning(this.$t('other.a557')+falg.storeItem.cusCode + this.$t('other.a2109'))

                        }else if(isStoreItem){
                             this.$message.warning(isStoreItem.storeItem.cusCode +this.$t('other.a2110'))
                        }else{

                            this.targetlist.push(p)
                        }
                    })
                    }
                }
                if(res.data.list[0].orderFlag == "SELLER_AUDITED"){
                    this.targetlist=res.data.list[0].copyOrder.variantList
                    let list=JSON.parse(localStorage.getItem('purchaseItems'))
                    if(list){
                        list.forEach(p => {
                        p.totalVolume=p.packageHeight*p.packageLength*p.packageWidth*Number(p.num)/1000000
                        let falg=this.targetlist.find(item => item.storeItem.cusCode == p.cusCode)

                        if(falg){
                            this.$message.warning(this.$t('other.a557')+falg.storeItem.cusCode + this.$t('other.a2109'))

                        }else{

                            this.targetlist.push(p)
                        }
                    })
                    }
                }
           
                
                //获取头程消息
                 userStoreItemsApi
                .getRuler({storeId:res.data.list[0].storeId,userId:this.userId})
                .then(res => {
                    if(res.code === 200){
                        console.log(res.data)
                        this.tableData=res.data

                        let fbsIndex=res.data.findIndex(item => item.fbsId == data.fbsId)
                        let fbsItem=res.data.find(item => item.fbsId == data.fbsId)

                        this.multipleSelection=fbsItem ? [fbsItem] : []
                       setTimeout(() => {
                           this.toggleSelection(this.tableData[fbsIndex])
                       },700)
                    }
                })
             }
         })
       }else{
           this.targetStoreId=this.$route.query.storeId
            this.targetlist=JSON.parse(localStorage.getItem('purchaseItems'))
            console.log('targetlist',this.targetlist);
            this.targetlist.forEach(p => {
                p.totalVolume=p.packageHeight*p.packageLength*p.packageWidth*Number(p.num)/1000000
                p.cusCode=p.cuscode ? p.cuscode : p.cusCode
            })
                userStoreItemsApi
                .getRuler({storeId:this.$route.query.storeId,userId:this.userId})
                .then(res => {
                    if(res.code === 200){
                        console.log(res.data)
                        this.tableData=res.data
                    }
                })
       }
      
    },

    addNewProduct(){
    this.$router.push({path:'/purchaseProduct',query:{purchaseId:this.purchaseOrderId}})
    },


    toggleSelection(row) {
        if(row){
              this.$refs.multipleTable.toggleRowSelection(row);
        }

        console.log(this.multipleSelection)

       
      
      },

    conversion(code){
        return utils.goodsType(code)
    },

    getCountry(id){
        return  utils.conutryConversion(id)
    },

    goBack(){
        if(this.$route.query.type && this.$route.query.stockType){
            this.$router.push({
				  path:'/stockProduct/stockRemind',
				  query:{
                      type:this.$route.query.type,
                      stockType:this.$route.query.stockType,
				  }
			  })
              
        }else if(this.purchaseOrderId){
            this.$router.push('/sellerpurchase')
        }else{
            this.$router.push('/factorysupply/inbound')
        }
    },
    updatestatus(purchaseOrderId){
        api
        .updatepurchasestatus({
          purchaseOrderId    : purchaseOrderId,
          purchaseOrderStatus : 'RECEIVED_BY_STOCK',
          userId : this.userId,
          description  : this.$t('other.a1216')
        })
        .then((res) => {
         
          if(res.code =='ok'){
               
          }else{
            this.$message.warning(res.msg);
          }
        });
    },//
    
    createPurchaseId(){
        console.log(this.targetlist)
        let variantList = [];
        let chooseList = this.targetlist;
       
        console.log('chooseList',chooseList)
        

        if(this.actualDate < 3){
            this.$confirm(this.$t('other.a2111'), this.$t("other.a142"), {
            confirmButtonText: this.$t("other.a884"),
            cancelButtonText: this.$t('other.a146'),
            type: 'warning'
            }).then(() => {})
            return 

        }
       
        if (chooseList.length == 0) {
            this.$message.warning(this.$t('other.a2112'));
            return;
        }else if(!this.value1) {
             this.$message.warning(this.$t('other.a2113'))
            return;
        }
      
        let dateOfShip=utils.setNowTimes(this.value1).replace(/\s*/g,"");
        for (let i = 0; i < chooseList.length; i++) {
            if (chooseList[i].num == 0 || chooseList[i].num == undefined) {
                this.$message.warning(this.$t('other.a2114'));
                return;
            }else if(chooseList[i].storeId !== chooseList[0].storeId) {
                this.$message.warning(this.$t('other.a2115'))
                return 
            }
            let variation = {
                anotherName: chooseList[i].anotherName,
                cost: chooseList[i].cost,
                cusCode: chooseList[i].cusCode,
                image: chooseList[i].image,
                itemSku: chooseList[i].itemSku,
                itemName: chooseList[i].itemName,
                variantName: chooseList[i].skuName,
                variantNum: chooseList[i].num,
                variant_id:chooseList[i].variation.variationId ,
                packageHeight:chooseList[i].packageHeight,
                packageLength:chooseList[i].packageLength,
                packageWidth:chooseList[i].packageWidth,
                weight:chooseList[i].weight,
                groupId:chooseList[i].groupId,
            }
            variantList.push(variation);
        }
        let param = {
            messageToSeller: this.textarea,
            storeId: chooseList[0].storeId,
            userId: this.userId,
            variantList: variantList,
            dateOfShip:dateOfShip,
            shippingCost:this.shipCost,
            fbs:this.multipleSelection.length ? true : null,
            fbsId:this.multipleSelection.length ? this.multipleSelection[0].fbsId : null
            
    
        }
        console.log('hhh',param)
        
        api
        .createPurchaseOrder(param)
        .then(res => {
            if (res.code === 200) {
                var parm = [];
                this.targetlist.map((item)=>{
                    parm.push({orderId:item.orderId})
                })
                let obj = {};
                parm = parm.reduce((cur,next) => {
                    obj[next.orderId] ? "" : obj[next.orderId] = true && cur.push(next);    return cur;
                },[]) 
              
                let text =this.$t('other.a2116') + res.data.purchaseOrderId

                this.$confirm(text, this.$t("other.a142"), {
                    confirmButtonText: this.$t('other.a1552'),
                    type: 'success'
                }).then(() => {
                    // // 判断是否是过能采购单创建的入库
                    if(this.$route.query.typeNum == 'second' ){
                        let purchaseArrList=JSON.parse(localStorage.getItem('purchaseIdArrList'))
                        api
                        .remotePorderAndWorder({
                            purchaseOrderIdList:purchaseArrList,
                            storagePurchaseOrderId:res.data.purchaseOrderId
                        })
                        .then(res => {
                        if(res.code === 200 ){
                        console.log('desc',res.data)
                        }else{
                        this.$message.warning(res.msg)
                        }
                        })
                        
                    }
                     this.$router.push({path:'/factorysupply/inbound'})
                })  
            }else if(res.code === 700){
                this.$message.warning(this.$t('other.a2117'))
            }else{
                this.$message.warning(res.msg)
            }
        })
    },

 
    sellerUpdat(){
        let variantList = [];
        let chooseList = this.targetlist;
       if( !this.multipleSelection[0]){
           this.multipleSelection=[]
           console.log(this.multipleSelection)
       }
        
       console.log(chooseList)
        if (chooseList.length == 0) {
            this.$message.warning(this.$t('other.a2112'));
            return;
        }else if(!this.value1) {
             this.$message.warning(this.$t('other.a2113'))
            return;
        }
      
        let dateOfShip=this.value1
        for (let i = 0; i < chooseList.length; i++) {
            if (chooseList[i].num == 0 || chooseList[i].num == undefined) {
                this.$message.warning(this.$t('other.a2114'));
                return;
            }else if(chooseList[i].storeId !== chooseList[0].storeId) {
                this.$message.warning(this.$t('other.a2115'))
                return 
            }
            let variation = {
                anotherName: chooseList[i].anotherName,
                cost: chooseList[i].cost,
                cusCode: chooseList[i].cusCode,
                image: chooseList[i].image,
                itemSku: chooseList[i].itemSku,
                itemName: chooseList[i].itemName,
                variantName: chooseList[i].skuName,
                variantNum: chooseList[i].num,
                variant_id:chooseList[i].variationId ,
                packageHeight:chooseList[i].packageHeight,
                packageLength:chooseList[i].packageLength,
                packageWidth:chooseList[i].packageWidth,
                weight:chooseList[i].weight,
                groupId:chooseList[i].groupId,
            }
            variantList.push(variation);
        }
        let param = {
            messageToSeller: this.textarea,
            storeId: this.storeId,
            userId: this.userId,
            variantList: variantList,
            dateOfShip:dateOfShip,
            shippingCost:Number(this.shipCost),
            fbs:this.multipleSelection.length ? true : null,
            fbsId:this.multipleSelection.length ? this.multipleSelection[0].fbsId : null,
            purchaseOrderId:this.purchaseOrderId
            
    
        }
        console.log('卖家修改',param)
        
        sellerpurchaseApi
        .sellerUpdatePurchase(param)
        .then(res => {
            if (res.code === 200) {
                 this.$message.success(this.$t('other.a2118'))
                 
                 setTimeout(() => {
                      this.$router.push('/sellerpurchase')
                 },1000)
                
            }else if(res.code === 700){
                this.$message.warning(this.$t('other.a2117'))
                
            }else{
                this.$message.warning(res.msg)
            }
        })

    },

    select(selection, row) {
        this.multipleSelection=[]; //清空已选
        
        // 选择项大于1时
        if (selection.length > 1) {
        let del_row = selection.shift();
        // console.log('把数组的第一个元素从其中删除后', selection);
        this.$refs.multipleTable.toggleRowSelection(del_row, false); // 用于多选表格，切换某一行的选中状态，如果使用了第二个参数，则是设置这一行选中与否（selected 为 true 则选中）
        }
        if(selection[0]){

            this.multipleSelection.push(selection[0])
        }else{
            this.multipleSelection=[]
        }
        console.log('选中', this.multipleSelection)
    },

    selectAll(selection) {
    this.multipleSelection=[]; //清空已选
   
    if (selection.length > 1) {
    selection.length = 1;
    this.multipleSelection.push(selection[0])
    }else{
    this.multipleSelection.push(selection[0])
    }
    
    },

    deleteChoose(item,index){
        this.targetlist.splice(index,1)
    },


    getTime(time){
        return utils.renderTime(time)
    },
    jvmf(){
        let month=utils.getCurrnetTime(this.value1)
        let now=utils.getNowTime()

        let  startDate = Date.parse(now);
        let  endDate = Date.parse(month);
         this.actualDate=(endDate-startDate)/(1*24*60*60*1000);
        if(this.actualDate < 3){
            this.$confirm(this.$t('other.a2111'), this.$t("other.a142"), {
            confirmButtonText: this.$t('other.a2119'),
            cancelButtonText: this.$t('other.a146'),
            type: 'warning'
            }).then(() => {
                
            })
        }
     
    }

}
}

</script>
<style lang="scss" scoped>
@import "~@assets/scss/mixins";

.purchaseDetail_wrapper{
    // @include  main-right-content();
    

    .check_desc{
        @include flex-between();
        margin: 10px 0;

        .check_desc_item{
            margin:0 10px;
        }

        .sec_item{
            @include flex-start()
        }
    }

    .check_desc:nth-child(3){
        display: flex;
        justify-content: space-between;
        padding-right: 15px;
        align-items: center;
    }


    .check_Top{
        position: fixed;
        z-index: 99;
        top: 50px;
        width: calc(100% - 235px);
        background-color: #fff;
        border-bottom: 1px solid #eee;
      

    }
    .check_header{
        padding: 10px 0;
    }

    .check_table{
      
        margin-top: 105px;
        width: calc(100% - 15px);

        .check_title{
            font-size: 18px;
            font-weight: bold;
            padding: 10px 0;
        }
    }

    .textarea{
        margin-bottom: 100px;
        margin-top: 10px;
    }
  
}

</style>